import { goRequest } from '../utils/httpClientTs';
import {
  CompleteNotificationResponse,
  DashboardNewsfeed,
  DashboardNotification,
  MyChapter,
  UpdateLoginTimeResponse,
} from '../types/dashboard';

export const getNewsfeeds = async (): Promise<DashboardNewsfeed[]> => {
  return goRequest<DashboardNewsfeed[]>({
    url: '/dashboard/newsfeeds',
    method: 'GET',
  });
};

export const getNotifications = async (): Promise<DashboardNotification[]> => {
  return goRequest<DashboardNotification[]>({
    url: '/dashboard/notifications',
    method: 'GET',
  });
};

export const getMyChapter = async (): Promise<MyChapter> => {
  return goRequest<MyChapter>({
    url: '/dashboard/my-chapter',
    method: 'GET',
  });
};

export const updateLoginTime = async (): Promise<UpdateLoginTimeResponse> => {
  return goRequest<UpdateLoginTimeResponse>({
    url: '/dashboard/update-login-time',
    method: 'POST',
  });
};

export const completeNotification = async (
  userNotificationTaskId: string
): Promise<CompleteNotificationResponse> => {
  return goRequest<CompleteNotificationResponse>({
    url: `/dashboard/notifications/${userNotificationTaskId}/complete`,
    method: 'POST',
  });
};
